var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMucoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdd2e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    className: "cls-1",
    d: "M33.644,2.963a7.665,7.665,0,0,1,11.923-.23L48,5.6c-1.857,1.6-17.782,16.039-4.876,31.478L33.639,45C20.413,29.181,26.005,13.061,33.644,2.963ZM4.859,37.077C18.1,21.239.744,6.244,0,5.613L2.417,2.757a7.665,7.665,0,0,1,11.932.219c7.634,10.1,13.214,26.213-.006,42.024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMucoSmall);
export default __webpack_public_path__ + "static/media/icon-muco-small.1f17b193d927425149790ed38cf509aa.svg";
export { ForwardRef as ReactComponent };